import { IconWithText } from 'common/icon/icon-with-text.js';
import { getAccessStatus } from 'utilities/status/state-access.js';
import { StatusAccess } from 'utilities/status/status-access.js';

export const SkiBit = ({ status }: { status?: StatusAccess }) => {
  if (status) {
    const statusConfig = getAccessStatus(status);
    return (
      <IconWithText icon={statusConfig.icon} classes="IconWithText--vCenter u-mT-sm">
        <h4 className="u-mT-0 u-mB-0">{statusConfig.label}</h4>
      </IconWithText>
    );
  }
  return null;
};
